exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.navbar-light .main-menu li .nav-link[data-v-2ccea6dc]{\n\tpadding-left: 16px;\n\tpadding-right: 16px;\n}\n.dropdown-menu.sub-menu[data-v-2ccea6dc]{\n\tdisplay: none;\n}\n.dropdown-menu.sub-menu .sub-nav-item .nav-link[data-v-2ccea6dc]{\n\tpadding: 8px;\n}\n.dropdown-menu.sub-menu.open[data-v-2ccea6dc]{\n\tdisplay: block;\n}\n\n", ""]);

